import React,{ useState, useEffect } from "react";
import { 
    Button,
    Form,
    Input,
    Select,
    Alert
} from 'antd';

import axios from 'axios';

import { 
    CheckCircleOutlined,
    CloseCircleOutlined
} from '@ant-design/icons';

function RateChecker() {

    const [phoneNumber, setPhoneNumber] = useState('');
    const [phoneNumberValid, setPhoneNumberValid] = useState(false);
    const [phoneNumberValidSuffix, setPhoneNumberValidSuffix] = useState(<></>);
    const [alertMarkup, setAlertMarkup] = useState(<></>);

    const [countryCode, setCountryCode] = useState( '1' );
    const [rateChecking, setRateChecking] = useState(false);
    
    const [form] = Form.useForm();
    const siteDomain = headerVars.siteDomain;

    const handleOnInputChange = ( e ) => {
        let currentVal = e.target.value;
        let inputID = e.target.id;
        let form_data = new FormData;
        let isValid = validateDestination( currentVal );
        let validationSuffix = <></>;

        validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

        let theNumber = isValid ? currentVal : '';

        setPhoneNumberValid( isValid );
        setPhoneNumber( theNumber );
        setPhoneNumberValidSuffix( validationSuffix );
    }

    const handleCountryCodeChange = ( value ) => {
        setCountryCode( value );
    }

    const handleGetRate = () => {
        setRateChecking( true );

        let form_data = new FormData;
        form_data.append('action', 'get_long_distance_rates');
        form_data.append('code', countryCode);
        form_data.append('destination', phoneNumber);

        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};

        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function(response){
            //console.log( 'response:: ', response.data );

            if( response.data == '' ) {
                setAlertMarkup( <Alert message={ 'Sorry, that does not appear to be a valid phone number.' } type="warning" /> );
            } else {
                setAlertMarkup( <Alert message={ response.data } type="success" /> );
            }
            
            
            setRateChecking( false );

        })
        .catch(function (error) {
            console.log(error);
            setAlertMarkup( <Alert message={ error } type="error" /> );
            setRateChecking( false );
        })
        .finally(function () {
            // always executed 
        });


        /**
         * jQuery.ajax({
                type: "POST",
                url: requestUrl.ajax_url,
                data: {
                    action: 'get_long_distance_rates',
                    'code': codeInput,
                    'destination': destination
                },
                success: function( data ) {
                    var response = data.substring(0, data.length - 1)
                    //console.log("=====: "+response);
                    preloader.removeClass('active');
                    if( response == '' ) {
                        errorMsg.html('Sorry, that does not appear to be a valid phone number.').show();
                    } else {
                        result.html(response);
                        result.addClass('active');
                    }
                },
                error: function( data ) {
                    preloader.removeClass('active');
                }
            });
         */
    }

    function validateDestination( destination ) {
        destination = destination.replace(/[^a-zA-Z0-9]/g, ''); //strip special characters
        
        if( isNumeric( destination ) ) {
            if( destination.length == 6 ) {
                return true;
            }
        } 

        return false;
    }

    function isNumeric(str) {
        if (typeof str != "string") {
            return false // we only process strings!  
        } 
        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
               !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
    }

    return (
        <div className="startca-react-rate-checker-container">
            <h3>Select the country code & enter the first 6 digits of the phone number.</h3>
            <div className="rate-checker-form">
                <Form
                    form={ form }
                >
                    <div className="form-column-row-inline">
                        <Form.Item
                            labelCol={{ span: 24 }}
                            label="View long distance rate for:"
                        >
                            <Input 
                                addonBefore={
                                    <Select 
                                        defaultValue="1" 
                                        style={{ minWidth: '75px' }}
                                        onChange={ handleCountryCodeChange }
                                    >
                                        <Option value="1">1</Option>
                                        <Option value="011">011</Option>
                                    </Select>
                                } 
                                onChange={handleOnInputChange}
                                placeholder="000000"
                                suffix={ phoneNumberValidSuffix }
                            />
                        </Form.Item>
                        <Form.Item
                                label=""
                                name="qualification-address-apply-button"
                            >
                            <Button 
                                type="primary"
                                loading={ rateChecking }
                                disabled={ phoneNumberValid ? false : true }
                                onClick={ handleGetRate }>
                                View Rate
                            </Button>
                        </Form.Item>
                    </div>
                </Form>
            </div>
            { alertMarkup }
        </div>
    )
}

export default RateChecker